export default __webpack_public_path__ + "static/identity-mock-m2-9d956120c0d54bcc097343adb274d97b.png";